import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const ConfirmationPopup = ({
  title,
  confirmationMessage,
  handleYes,
  handleNo,
  yesButtonText,
  noButtonText,
}) => {
  const { t } = useTranslation();

  return (
    <div className="custom-alert-pop confirmation_popup">
      <div className="custom-alert-container">
        <div className="custom-alert-wrap">
          <div className="custom-alert-header">
            <h4>{title}</h4>
          </div>
          <div className="custom-alert-body">
            <p>{confirmationMessage}</p>
            <div className="alert-buttons">
              <a title={t("ok_txt")} onClick={handleYes} className="popup-alert-btn button">
                {yesButtonText || t("ok_txt")}
              </a>
              <a title={t("cancel_txt")} onClick={handleNo} className="popup-alert-btn button">
                {noButtonText || t("cancel_txt")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
